import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Contract } from "../../classes/contract";

@Component({
  selector: 'app-contract-founder-create-modal',
  templateUrl: './contract-founder-create-modal.component.html',
  styleUrls: ['./contract-founder-create-modal.component.css']
})
export class ContractFounderCreateModalComponent implements OnInit {
  contract = new Contract();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
